(function communityAndNeighBorhoodHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const previousCommunityAndNeighBorhoodHandler = global.NewHomeSource.CommunityAndNeighBorhoodHandler;

  /**
   * @constructs NewHomeSource.CommunityAndNeighBorhoodHandler
   */
  function CommunityAndNeighBorhoodHandler() {
  }

  /** 
   *  hideAllSections: function to hide all tabs of the sub menu
   */
  function hideAllSections() {
    const arraySections = document.querySelectorAll('[data-sub-menu-element]');
    arraySections.forEach((section) => {
      section.setAttribute('hidden', '');
      section.setAttribute('aria-hidden', 'true');
    });
  }

  /**
   * turnOnASection: function to show a specific section
   * @param {string} name data parameter with the name of the section
   */
  function showASection(name) {
    const section = document.querySelector('[data-sub-menu-element="' + name + '"]');
    if (section) {
      section.removeAttribute('hidden');
      section.setAttribute('aria-hidden', 'false');
    }
  }

  /**
  * Removes the element focus.
  * @param {any} element
  */
  function removeTabFocus(element) {
    element.classList.remove('nhs-c-button--tap-light-active');
    element.setAttribute('aria-selected', 'false');
    element.setAttribute('tabindex', '-1');
  }

  /**
   * Toggles the active element tab.
   * @param {any} target
   */
  function setActiveTab(target) {
    const selectedItem = target;
    const subMenuItems = document.querySelectorAll('[data-subnav-items] [data-sub-menu-name]');

    if (selectedItem) {
      subMenuItems.forEach(removeTabFocus);
      selectedItem.classList.add('nhs-c-button--tap-light-active');
      selectedItem.setAttribute('aria-selected', 'true');
      selectedItem.setAttribute('tabindex', '0');
    }
  }

  /**
   * Activates and shows the content section represented by a tab.
   * @param {HTMLElement} tab tab element to activate.
   */
  function activateTab(tab) {
    if (!tab?.dataset.subMenuName) {
      return;
    }

    setActiveTab(tab);
    hideAllSections();
    showASection(tab.dataset.subMenuName);
  }

  /**
   *  performClickOnATab: function to control the event click on the tab events
   */
  function performClickOnATab(event) {
    activateTab(event.currentTarget);
  }

  /**
   * Handles keyboard navigation for tabs.
   * @param {KeyboardEvent} event keyboard event from tab element.
   */
  function performKeyDownOnATab(event) {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!keys.includes(event.key)) {
      return;
    }

    const arrayTabs = Array.from(document.querySelectorAll('[data-subnav-items] [data-sub-menu-name]'));
    const currentIndex = arrayTabs.indexOf(event.currentTarget);
    if (currentIndex === -1 || arrayTabs.length === 0) {
      return;
    }

    event.preventDefault();

    let nextIndex = currentIndex;
    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % arrayTabs.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + arrayTabs.length) % arrayTabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = arrayTabs.length - 1;
    }

    const nextTab = arrayTabs[nextIndex];
    if (nextTab) {
      nextTab.focus();
      activateTab(nextTab);
    }
  }

  /**
   *  setEventsToTabs: function to set the event call back to the tabs
   */
  function setEventsToTabs() {
    const arrayTabs = document.querySelectorAll('[data-sub-menu-name]');
    arrayTabs.forEach((tab) => {
      tab.addEventListener('click', performClickOnATab);
      tab.addEventListener('keydown', performKeyDownOnATab);
    });
  }

  /**
   *  init: function to start events
   */
  CommunityAndNeighBorhoodHandler.init = function Init() {
    setEventsToTabs();
  };


  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.CommunityAndNeighBorhoodHandler to the previous script.
   */
  CommunityAndNeighBorhoodHandler.noConflict = function noConflict() {
    global.NewHomeSource.CommunityAndNeighBorhoodHandler = previousCommunityAndNeighBorhoodHandler;
    return CommunityAndNeighBorhoodHandler;
  };

  /**
   * @private
   * trackGA4Event: tracks the event when the tools list is expanded.
   * @param {object} event result of the click on the page.
   */
  const trackGA4CollapseEvent = function (event) {
    if (!event?.target?.matches('[data-neighborhood-event]')) {
      return;
    }

    const ga4Event = {
      eventType: 'GA4Event',
      eventName: event.target.dataset.neighborhoodEvent,
      params: {
        click_target: event.target.dataset.neighborhoodClickTarget,
        position: event.target.dataset.neighborhoodPosition,
        click_target1: event.target.dataset.neighborhoodClickTarget1
      }
    };

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: ga4Event
      }
    }));
  };

  global.document.body.addEventListener('click', trackGA4CollapseEvent);

  global.NewHomeSource.CommunityAndNeighBorhoodHandler = CommunityAndNeighBorhoodHandler;

  return CommunityAndNeighBorhoodHandler;
}(globalThis));
